// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wVCKWdwIeHtCsGBOnZwd{padding:12px 8px 12px 12px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/compliance/ui/ContactForm/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,0BAAA","sourcesContent":[".inputPadding {\n  padding: 12px 8px 12px 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputPadding": `wVCKWdwIeHtCsGBOnZwd`
};
export default ___CSS_LOADER_EXPORT___;
